import { useTranslation } from 'react-i18next';

import { Button, Form, Input } from '@arco-design/web-react';
import { useCallback } from 'react';
import { loginLDAP } from '../service';

const FormItem = Form.Item;

const primaryBtnStyle: React.CSSProperties = {
  fontWeight: 600,
  borderRadius: '4px',
  marginTop: 16,
};

export default function LDAP({
  onSuccess,
}: {
  onSuccess: (res: { accessToken?: string; refreshToken?: string }) => void;
}) {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const handleLogin = useCallback(() => {
    form
      .validate()
      .then((values) => {
        loginLDAP(values).then(onSuccess);
      })
      .catch(() => {});
  }, [form, onSuccess]);

  return (
    <Form form={form} layout="vertical">
      <FormItem
        field="name"
        rules={[{ required: true, message: t('login-page:account.cannot.be.empty') }]}
      >
        <Input placeholder={t('common:please.enter.username')} onPressEnter={handleLogin} />
      </FormItem>
      <FormItem
        field="password"
        rules={[{ required: true, message: t('login-page:password.cannot.be.empty') }]}
      >
        <Input.Password
          placeholder={t('common:please.enter.password')}
          onPressEnter={handleLogin}
        />
      </FormItem>
      <Button long type="primary" style={primaryBtnStyle} onClick={handleLogin}>
        AD {t('login-page:login')}
      </Button>
    </Form>
  );
}
